export default "__VITE_ASSET__yMk4heuh__"